export const initialPools = [
  {
    id: 'POOL_01',
    name: 'Koramangala Center',
    title: 'Premium Olympic Sized Indoor Pool',
    pic: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=600&q=80',
    address: '123 Tech Park, Koramangala, Bangalore - 560034',
    facilities: ['Temperature Controlled', 'Showers & Lockers', 'Cafeteria', 'Parking'],
    mapUrl: 'https://maps.google.com',
    programs: ['Group Training', 'Personal Training', 'Premium Membership', 'Pay and Use Pool'],
    isActive: true // NEW: Pool Status
  },
  {
    id: 'POOL_02',
    name: 'Whitefield Pool',
    title: 'Rooftop Infinity Training Pool',
    pic: 'https://images.unsplash.com/photo-1519315901367-f34ff9154487?w=600&q=80',
    address: '78 Blue Ridge, Whitefield, Bangalore - 560066',
    facilities: ['Rooftop View', 'Gym Access', 'Towel Service'],
    mapUrl: 'https://maps.google.com',
    programs: ['Group Training', 'Personal Training'],
    isActive: true // NEW: Pool Status
  }
];
// ... keep other exports unchanged
export const initialStudents = [
  { 
    id: '101', name: 'Rahul Sharma', type: 'Adult', 
    email: 'rahul@email.com', mobile: '+91 9876543210', 
    whatsapp: '+91 9876543210', emergencyContact: '+91 9988776655',
    dob: '1995-08-15', address: '123 Tech Park, Koramangala, Bangalore - 560034',
    profilePic: 'https://ui-avatars.com/api/?name=Rahul+Sharma&background=fbbf24&color=0f172a&size=150'
  },
  { 
    id: '102', name: 'Priya Patel', type: 'Child', 
    email: 'priya.parent@email.com', mobile: '+91 9876543211', 
    whatsapp: '+91 9876543211', emergencyContact: '+91 9988776656',
    dob: '2015-04-20', address: '45 Green Avenue, Indiranagar, Bangalore - 560038',
    profilePic: 'https://ui-avatars.com/api/?name=Priya+Patel&background=38bdf8&color=ffffff&size=150'
  },
  { 
    id: '103', name: 'Arjun Singh', type: 'Adult', 
    email: 'arjun@email.com', mobile: '+91 9876543212', 
    whatsapp: '+91 9876543212', emergencyContact: '+91 9988776657',
    dob: '1998-11-05', address: '78 Blue Ridge, Whitefield, Bangalore - 560066',
    profilePic: 'https://ui-avatars.com/api/?name=Arjun+Singh&background=fbbf24&color=0f172a&size=150'
  }
];

export const initialBatches = [
  {
    id: 'B001', title: "Morning Advanced Warriors", type: "Group Training",
    fees: "5000", hoursCount: 40, hoursPerDay: 2, startTime: "06:00", endTime: "08:00",
    duration: "0 Y, 3 M, 0 D", weekdays: [1, 2, 3, 4, 5],
    isActive: true // NEW: Batch Status
  }
];

export const initialEnrollments = [
  {
    id: 'E001', studentId: '101', batchId: 'B001', startDay: '2026-03-01', endDay: '2026-06-01',
    amountPaid: '5000', feesPaidOn: '2026-02-28', modeOfPayment: 'UPI', txRef: 'UPI987654321',
    usedHours: 4, balanceHours: 36,
    attendance: [
      { date: '2026-03-02', start: '06:00', end: '08:00', total: '02:00' },
      { date: '2026-03-03', start: '06:00', end: '08:00', total: '02:00' }
    ]
  }
];